if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        // Wait briefly to ensure modal content is rendered
        setTimeout(() => {
          // Attempt to find the toggle button and container inside the modal
          const toggleButton = this.querySelector("#toggle-variants");
          const container = this.querySelector("#main-variant-items");
          if (!toggleButton || !container) return; // Exit if not found

          // Attach a click handler to the toggle button
          toggleButton.onclick = function () {
            // Determine display style based on viewport width:
            const displayType = window.innerWidth < 990 ? "grid" : "table-row";
            const variantRows = container.querySelectorAll("tbody tr.variant-item");
            const expanded = toggleButton.getAttribute("data-expanded") === "true";
            // Toggle rows – keep the first two always visible.
            for (let i = 2; i < variantRows.length; i++) {
              variantRows[i].style.display = expanded ? "none" : displayType;
            }
            // Update the button text and state.
            if (expanded) {
              toggleButton.textContent = "Show All Variants";
              toggleButton.setAttribute("data-expanded", "false");
            } else {
              toggleButton.textContent = "Collapse Variants";
              toggleButton.setAttribute("data-expanded", "true");
            }
          };

          // Reset to default state in the modal
          toggleButton.textContent = "Show All Variants";
          toggleButton.setAttribute("data-expanded", "false");
        }, 100); // 100ms delay (adjust if needed)
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
